import request from '../../../request/request';

const getAuthorities = () => {
  return request({
    url: '/webapi/authority/list'
  });
};

const createAuthority = ({
  name,
  description,
  resource,
  requiredAuthority
}) => {
  return request({
    url: '/webapi/authority/create',
    method: 'POST',
    data: { name, description, resource, requiredAuthority }
  });
};

const editAuthority = ({ name, description, resource, requiredAuthority }) => {
  return request({
    url: `/webapi/authority/${name}/update-details`,
    method: 'POST',
    data: { description, resource, requiredAuthority }
  });
};

const deleteAuthority = ({ name }) => {
  return request({
    url: `/webapi/authority/${name}`,
    method: 'DELETE'
  });
};

export { getAuthorities, createAuthority, editAuthority, deleteAuthority };
